// extracted by mini-css-extract-plugin
module.exports = {"pagination_container":"paPagination_pagination_container__7_t27"};